module.exports = require("pkg-dir");